import { AnnotationsKnob, ViewSettingsForm } from 'components/ChartTools';
import { SettingsForm } from './Settings';
import { Actions, Action, GetAppIcon } from '@gogame/components';

export const ChartActions = ({
  annotationUniqueId,
  annotationsSettings,
  onChangeViewSettings,
  onChangeSettings,
  settings,
  summableSeries,
  visibleSeries,
  handleExportVisible,
  handleExportAll,
  viewSettings,
}) => {
  return (
    <Actions limit={10}>
      <Action
        component={() => (
          <AnnotationsKnob
            id={annotationUniqueId}
            showAnnotations={annotationsSettings.showAnnotations}
          />
        )}
      />
      <Action
        component={() => (
          <ViewSettingsForm
            showBrushControl={true}
            withLegendDetails={true}
            initialValues={viewSettings}
            onSubmit={onChangeViewSettings}
          />
        )}
      />
      <Action
        component={() => (
          <SettingsForm
            onSubmit={onChangeSettings}
            initialValues={settings}
            seriesSumDisabled={!summableSeries.length}
          />
        )}
      />
      <Action
        icon={<GetAppIcon />}
        label={'Export'}
        disabled={!visibleSeries.length}
      >
        <Action label={'Export visible'} onClick={handleExportVisible} />
        <Action label={'Export all'} onClick={handleExportAll} />
      </Action>
    </Actions>
  );
};
